// @flow
import { PAYMENT_PROCESSORS } from '../../../../lib/constants'
import store from '../stores/configureStore'

/**
 * Check if we should show the currency conversion link,
 * which allows the user to select a currency conversion option
 * @param {Object} selectedFundingOption - the selected funding option
 * @return {Boolean} showCurrencyConversionLink - if we should show the conversion link
 */
export function shouldShowCurrencyConversionLink(
  selectedFundingOption: Object = {}
): boolean {
  const { funding_sources = [] } = selectedFundingOption

  // we pull the last funding source off the array which will be the credit card
  const fundingSourceToCheck = funding_sources[funding_sources.length - 1]
  if (fundingSourceToCheck) {
    return !fundingSourceToCheck.disableCurrencyConversion
  }
  return false
}

export function getPaymentProcessor(currencyCode: string): Object {
  const {
    amount: { recipientPaymentDestinationsMap = {} } = {},
  } = store.getState()

  return recipientPaymentDestinationsMap[currencyCode] || {}
}

export function isXoomCurrency(currencyCode: string): boolean {
  const { paymentProcessor } = getPaymentProcessor(currencyCode)

  return isXoomPaymentProcessor(paymentProcessor)
}

/**
 * Takes a payment processor name and indicates if its a Xoom one.
 * @param {string} paymentProcessor Any paymentProcessor name "PAYPAL", "XOOM", ETC
 * @returns {boolean}
 */
export function isXoomPaymentProcessor(paymentProcessor: string = ''): boolean {
  return paymentProcessor === PAYMENT_PROCESSORS.XOOM
}
